import React, { useEffect, useState } from 'react'
import axios from 'axios'
import './Booking.css'

const getAuthToken = () =>
  document.cookie.replace(/(?:(?:^|.*;\s*)auth\s*=\s*([^;]*).*$)|^.*$/, "$1")

const PaymentHistory = ({ summary }) => {
  const [payments, setPayments] = useState([])

  const getPayments = async () => {
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_API_BASE_URL}/api/banking/get_payment`,
        { headers: { auth: getAuthToken() } }
      )
      setPayments(response.data.payments || [])
    } catch (error) {
      console.error('Error fetching payments:', error)
    }
  }

  useEffect(() => { getPayments() }, [])

  return (
    <div className="ph-section">
      <div className="ph-section-header">
        <h2 className="ph-section-title">Payment History</h2>
      </div>
      {payments.length === 0 ? (
        <div className="ph-empty">No payment records found.</div>
      ) : (
        <div className="ph-table-wrap">
          <table className="ph-table">
            <thead>
              <tr>
                <th>#</th>
                <th>Payment ID</th>
                <th>Amount Paid</th>
                <th>Date</th>
              </tr>
            </thead>
            <tbody>
              {payments.map((payment, index) => (
                <tr key={payment.id}>
                  <td>{index + 1}</td>
                  <td>{payment.id}</td>
                  <td className="ph-amount">₹{payment.amount_paid}</td>
                  <td>{new Date(payment.paid_on).toLocaleDateString()}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  )
}

export default PaymentHistory
